import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, demo, repo }) => {
  return (
    <Col sm={6} md={4}>
      <div className="proj-card-wrapper">
        <img src={imgUrl} alt={title} className="proj-img" />

        <div className="proj-overlay">
          <h5>{title}</h5>
          <p>{description}</p>

          <div className="proj-links">
            <a href={demo} target="_blank" rel="noreferrer">
              <img
                src="https://cdn.simpleicons.org/googlechrome/ffffff"
                className="proj-icon"
                alt="Live Demo"
              />
            </a>

            <a href={repo} target="_blank" rel="noreferrer">
              <img
                src="https://cdn.simpleicons.org/github/ffffff"
                className="proj-icon"
                alt="GitHub Repo"
              />
            </a>
          </div>
        </div>
      </div>
    </Col>
  );
};
